<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>Настройка чатов MAX (бот оповещений)</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="ml-1 mb-3 mr-1 mt-2">
                        <p>
                            Укажите chat_id групп MAX через запятую.
                            Чтобы узнать chat_id группы — добавьте бота <b>MAX_ADMIN_NOTIFY_BOT</b> в группу,
                            напишите любое сообщение, бот ответит своим chat_id.
                            Используется бот с токеном <code>MAX_ADMIN_NOTIFY_BOT_TOKEN</code>.
                        </p>
                    </CRow>

                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Chat id групп для модераций
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="moderationChatIds" placeholder="example: 111111111, 212121212" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Chat id групп для всех заказов
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="orderChatIds" placeholder="example: 111111111, 212121212" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Chat id группы для отключения сервисов
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="disableServicesChatId" placeholder="example: 111111111" />
                                <small class="text-muted">Дублирует переменную окружения MAX_ID_GROUP_DISABLE_SERVICES</small>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'MaxSettings',

        data() {
            return {
                key: 'max',
                moderationChatIds: '',
                orderChatIds: '',
                disableServicesChatId: '',
            };
        },

        mounted() {
            this.loadSettings();
        },

        methods: {
            normalizeChatIds(value) {
                return (value || '').trim().split(',').map(i => i.trim()).filter(Boolean).join(',');
            },
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            moderationChatIds: this.normalizeChatIds(this.moderationChatIds),
                            orderChatIds: this.normalizeChatIds(this.orderChatIds),
                            disableServicesChatId: (this.disableServicesChatId || '').trim(),
                        }
                    })
                    .then(resp => {
                        const v = resp.data.value || {};
                        this.moderationChatIds = v.moderationChatIds || '';
                        this.orderChatIds = v.orderChatIds || '';
                        this.disableServicesChatId = v.disableServicesChatId || '';
                        this.$root.$emit('showAlert', 'Успешно сохранено.');
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            loadSettings() {
                Vue.axios
                    .get('/settings/' + this.key)
                    .then(resp => {
                        const v = resp.data && resp.data.value ? resp.data.value : {};
                        this.moderationChatIds = v.moderationChatIds || '';
                        this.orderChatIds = v.orderChatIds || '';
                        this.disableServicesChatId = v.disableServicesChatId || '';
                    })
                    .catch(() => {});
            },
        },
    };
</script>
